import { useEffect, useMemo } from 'react'
import useContentSize from "./useContentSize";
import useWindowSize from "./useWindowSize";
import PubSub, { Message } from "../../../Utils/pubSub";
import UrlParams from "../../../Utils/UrlParams";

export default function useIframeSize() {
  const contentSize = useContentSize()
  const windowSize = useWindowSize()

  const frameId = useMemo(
    () => new UrlParams(window.location.search).get('f'),
    [])

  useEffect(() => {
    const container = document.querySelector('body');
    if (container.offsetHeight === 0 || window.innerHeight === 0) {
      return;
    }

    PubSub.publish(Message.Resize(frameId), {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      contentWidth: container.offsetWidth,
      contentHeight: container.offsetHeight,
    });

  }, [contentSize, frameId, windowSize])

}
